import * as constants from './constants'

export const addCreditCard = (data, successCallback) => ({
    type: constants.ADD_PAYMENT_METHOD,
    data,
    successCallback,
})

export const addGuestCreditCard = (data, successCallback) => ({
    type: constants.ADD_GUEST_PAYMENT_METHOD,
    data,
    successCallback,
})

export const addPaymentMethodSuccess = () => ({
    type: constants.ADD_PAYMENT_METHOD_SUCCESS,
})

export const setDefaultCreditCard = creditCard => ({
    type: constants.SET_DEFAULT_CREDIT_CARD,
    creditCard,
})

export const removeCreditCard = creditCard => ({
    type: constants.REMOVE_CREDIT_CARD,
    creditCard,
})

export const initPayment = (card, paymentTotal, locationId, orderId) => ({
    type: constants.INIT_PAYMENT,
    card,
    paymentTotal,
    locationId,
    orderId,
})

export const pspVerificationResponse = (details, errors) => ({
    type: constants.PSP_VERIFICATION_RESPONSE,
    details,
    errors,
})

export const secure3dResponse = (details, errors) => ({
    type: constants.SECURE3D_RESPONSE,
    details,
    errors,
})

export const cancelSecure3d = () => ({
    type: constants.SECURE3D_CANCELLED,
})

export const getPSEPaymentBanks = () => ({
    type: constants.GET_PSE_PAYMENT_BANKS,
})

export const setPSEPaymentBanks = banks => ({
    type: constants.SET_PSE_PAYMENT_BANKS,
    banks,
})

export const paymentSuccess = (orderId, payId, cardToken) => ({
    type: constants.PAYMENT_SUCCESS,
    orderId,
    payId,
    cardToken,
})

export const paymentCancelled = () => ({
    type: constants.PAYMENT_CANCELLED,
})

export const paymentError = error => ({
    type: constants.PAYMENT_ERROR,
    error,
})

export const setPixQRCodeData = qrCodeData => ({
    type: constants.SET_PIX_QR_CODE_DATA,
    qrCodeData,
})
